import { createApiService } from "@/core/api/apiService";
import type {
  AppointmentManagementDto,
  AppointmentManagementLinkDto,
  AppointmentManagementResultDto,
} from "../types/appointmentManagementTypes";

function createAppointmentManagementApiService() {
  const api = createApiService("businesses");
  return {
    rotate: (businessId: string, appointmentId: string, dto: AppointmentManagementDto) =>
      api.post<AppointmentManagementLinkDto>(`/${businessId}/appointments/${appointmentId}/management-link/rotate`, dto, { cache: "no-store" }),
    revoke: (businessId: string, appointmentId: string, dto: AppointmentManagementDto) =>
      api.post<AppointmentManagementResultDto>(`/${businessId}/appointments/${appointmentId}/management-link/revoke`, dto, { cache: "no-store" }),
  };
}

export const appointmentManagementApiService = createAppointmentManagementApiService();
